<div class="container-fluid preview-container p-0 m-0">
  <div class="row p-0 m-0">
    <!-- FILTROS AVANZADOS -->
    @if (stateFilterSoftDelete) {
      <div class="col-12 p-0 m-0 mt-1">
        <efx-accordion id="accordion1" [multi]="false" [hideToggle]="false">
          <efx-accordion-item id="panel1" [hideToggle]="false" [isDisabled]="false" [isExpanded]="false">
            <div class="title acordion" [innerHTML]="'Filtros Avanzados'"></div>
            @for (colum of columnsNameDataTable; track colum) {
              <div class="content p-0 m-0 pe-3 pb-3 d-flex flex-column"
                [ngClass]="columnsNameDataTable.length > 6 ? 'col-2': '' "
                [style]="columnsNameDataTable.length > 6 ? '': 'width: '.concat( (100/columnsNameDataTable.length).toString(), '%' )"
                >
                <span class="label mb-1"> {{ colum.columLabel }} </span>
                <input [style]="'width: 95%'" class="efx-input p-0 ps-1" type="text"
                  (keyup)="applyFilter($event, colum.columVar)" [placeholder]="colum.columLabel" [id]="colum.columVar"
                  #inputRef />
                </div>
              }
            </efx-accordion-item>
          </efx-accordion>
        </div>
      }
      <!-- END FILTROS AVANZADOS -->

      <!-- TABLA -->
      <div class="col-12 p-0 m-0" style="overflow-x: auto;">
        <table class="efx-table" mat-table [dataSource]="dataSource" matSort aria-label="Datos fuente">
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="toggleAllRows($event.checked)"
                [checked]="checkedHeader(selection)"
                [indeterminate]="indeterminateHeader(selection)"
                [aria-label]="checkboxLabel()"
                [disabled]="disableCheckbox()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" style="pointer-events: none;">
              <mat-checkbox style="pointer-events: initial;"
                (click)="handleRowCheckboxClick($event, row)"
                (change)="changeRow($event, selection, row)"
                [checked]="checkedRow(selection, row)"
                [aria-label]="checkboxLabel(row)"
                [disabled]="disableCheckbox(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="update">
            <th mat-header-cell *matHeaderCellDef>Acciones
            </th>
            <td mat-cell *matCellDef="let row">
              <div class="d-flex">
                <button efxTooltip efxTooltipTitle="Actualizar contribución" efxTooltipPlacement="top"
                  efxTooltipMode="dark" class="efx-button-primary me-2" (click)="onColumSelect.emit(row)">
                  <span class="efx-icons">
                    autorenew
                  </span>
                </button>

                <button efxTooltip efxTooltipTitle="Descargar JSON" efxTooltipPlacement="top"
                  efxTooltipMode="dark" class="efx-button-secondary" (click)="onDownloadDetailDelete.emit(row)">
                  <span class="efx-icons">
                    download
                  </span>
                </button>
              </div>

            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="downloadDetail">
          <th mat-header-cell *matHeaderCellDef>Detalle
          </th>
          <td mat-cell *matCellDef="let row" matTooltip="Clic para descargar detalle">
            <span class="material-symbols-outlined cursor-pointer" (click)="onDownloadDetailDelete.emit(row)">
              download
            </span>
          </td>
        </ng-container> -->

        <!-- Column -->
        @for (columName of columnsNameDataTable; track columName) {
          <ng-container [matColumnDef]="columName.columVar">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ columName.columLabel | titlecase }}
            </th>
            <td mat-cell *matCellDef="let row">
              @if (columName.columVar === 'journalingTimestamp') {
                <div>
                  {{ row[columName.columVar] ? (row[columName.columVar] | date:'dd/MM/yyyy HH:mm:ss') : '-' }}
                </div>
              } @else {
                @if (columName.columVar === 'date' || columName.columVar === 'date_estado') {
                  {{ row[columName.columVar] === null ? '-' : row[columName.columVar] }}
                } @else {
                  {{ row[columName.columVar] === null ? '-' : row[columName.columVar] }}
                }
              }
            </td>
          </ng-container>
        }

        <!-- Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr [class]="mostrarCheckbox ? 'cursor-pointer': ''"
          [ngClass]="paintColor(row)" mat-row
        *matRowDef="let row; columns: displayedColumns" (click)="mostrarCheckbox ? onColumSelect.emit(row):''"></tr>
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">
            No hay datos que coincidan con el filtro "{{ textFilterTitle }}"
          </td>
        </tr>
      </table>
    </div>
    <!-- END TABLA -->

    <!-- PAGINATOR -->
    <div class="col-12 d-flex justify-content-between align-items-center flex-wrap p-0 m-0">

      <div class="selection-counter px-3">
        @if (selection.hasValue()) {
          <span>
            <strong>{{ selection.selected.length }}</strong> de <strong>{{ dataSource?.data?.length }}</strong> registros seleccionados
          </span>
        }
      </div>

      <mat-paginator
        class="flex-grow-1"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        [length]="lenghtData()"
        showFirstLastButtons
        aria-label="Select page">
      </mat-paginator>

    </div>
    <!-- END PAGINATOR -->

  </div>

<router-outlet></router-outlet>
